import { ReactNode } from 'react';
import { Input } from 'antd';
import { Field } from '../field/field';

interface ITextFieldProps {
  id: string;
  label: ReactNode;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  labelSize?: 'sm' | 'md';
  className?: string;
  transform?: (value: string) => string;
  spellCheck?: boolean;
}

export const TextField = ({ id, label, value, onChange, placeholder, labelSize, className, transform, spellCheck }: ITextFieldProps) => (
  <Field label={label} htmlFor={id} labelSize={labelSize}>
    <Input
      id={id}
      size="large"
      autoComplete="off"
      className={className}
      placeholder={placeholder}
      spellCheck={spellCheck}
      value={value}
      onChange={(event) => onChange(transform ? transform(event.target.value) : event.target.value)}
    />
  </Field>
);
